import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';

export type PostCustomerOrderFeedbackQuestionsRequestArgs = {
  orderId: number;
  questionId: number;
  answerId: number;
};

export type PostCustomerOrderFeedbackQuestionsResponse = {
  id: number;
  order_id: number;
  question_id: number;
  answer_id: number;
};

export const postCustomerOrderFeedbackQuestionsPath = (orderId: number) =>
  `/api/v2/orders/${orderId}/order_feedback_responses/`;

export async function postCustomerOrderFeedbackQuestions({
  orderId,
  questionId,
  answerId,
}: PostCustomerOrderFeedbackQuestionsRequestArgs) {
  return await send<PostCustomerOrderFeedbackQuestionsResponse>({
    path: postCustomerOrderFeedbackQuestionsPath(orderId),
    method: 'POST',
    body: {
      question_id: questionId,
      answer_id: answerId,
    },
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
